export const attached = {
  hylink_ac: "access_control",
};

export default attached;
